import { url } from 'mk/urls/autogenhelper';
import * as settingsUrls from 'mk2/apps/settings/urls';
import { Route } from 'mk2/containers/Application/Application';
import { USERNAME } from 'mk2/helpers/api';
import RedirectPage from 'mk2/pages/RedirectPage';

export const routes: Route[] = [{
    app: 'settings',
    exact: true,
    path: settingsUrls.settings,
    page: new RedirectPage({
        to: (props) => url(settingsUrls.settingsProfile, {username: props.requestUser.username}),
        permanent: true,
        authOnly: true,
    }),
}, {
    app: 'settings',
    exact: true,
    path: `/settingsapp/${USERNAME}/`,
    page: new RedirectPage<{username: string}>({
        to: (props) => url(settingsUrls.settingsProfile, {username: props.match.params.username}),
        permanent: true,
        authOnly: true,
    }),
}, {
    app: 'settings',
    exact: true,
    path: settingsUrls.settingsProfile,
    getPage: () => {
        return import('mk2/apps/settings/containers/Profile/ProfilePage' /* webpackChunkName: "settings.Profile" */);
    },
    modules: [ 'mk2/apps/settings/containers/Profile/ProfilePage' ],
}, {
    app: 'settings',
    exact: true,
    path: settingsUrls.settingsKids,
    getPage: () => {
        return import('mk2/apps/settings/containers/Kids/KidsPage' /* webpackChunkName: "settings.Kids" */);
    },
    modules: [ 'mk2/apps/settings/containers/Kids/KidsPage' ],
}, {
    app: 'settings',
    exact: true,
    path: settingsUrls.settingsKidAdd,
    getPage: () => {
        return import('mk2/apps/settings/containers/KidAdd/KidAddPage' /* webpackChunkName: "settings.KidAdd" */);
    },
    modules: [ 'mk2/apps/settings/containers/KidEdit/KidAddPage' ],
}, {
    app: 'settings',
    exact: true,
    path: settingsUrls.settingsKidEdit,
    getPage: () => {
        return import('mk2/apps/settings/containers/KidEdit/KidEditPage' /* webpackChunkName: "settings.KidEdit" */);
    },
    modules: [ 'mk2/apps/settings/containers/KidEdit/KidEditPage' ],
}, {
    app: 'settings',
    exact: true,
    path: settingsUrls.settingsAccount,
    getPage: () => {
        return import('mk2/apps/settings/containers/Account/AccountPage' /* webpackChunkName: "settings.Account" */);
    },
    modules: [ 'mk2/apps/settings/containers/Account/AccountPage' ],
}];
